import { cloneDeep } from 'lodash'

const DEFAULT_SECTION_STATE = {
  giftSelection: {
    drawerOpen: true,
    selectedPlan: null,
    selectedGift: null,
    giftNote: '',
  },
  contactInformation: {
    drawerOpen: true,
    firstName: '',
    lastName: '',
    email: '',
    gifter_date_of_birth: '',
  },
  shippingInformation: {
    drawerOpen: true,
  },
  paymentInformation: {
    drawerOpen: true,
    selectedPaymentOption: null,
    selectedPaymentMethod: null,
    savePaymentDetails: true,
  },
}
export const useMemberships = defineStore('memberships', () => {
  const { $axios } = useNuxtApp()

  const loading = ref(false)
  const giftableMemberships = ref([])
  const sectionState = ref(DEFAULT_SECTION_STATE)
  const visibleMemberships = computed(() =>
    giftableMemberships.value
      .filter((membership) => membership.has_visible_gift_term)
      .sort(
        (a, b) =>
          (a.gifting_position === null) - (b.gifting_position === null) ||
          a.gifting_position - b.gifting_position,
      ),
  )

  function setLoading(value) {
    loading.value = value
  }

  function setSectionState({ section, value }) {
    sectionState.value[section] = value
  }
  function clearSectionState() {
    sectionState.value = cloneDeep(DEFAULT_SECTION_STATE)
  }
  function setSectionDrawerOpen({ section, value }) {
    sectionState.value[section].drawerOpen = value
  }

  async function loadMemberships() {
    loading.value = true
    const { data } = await $axios.get('/api/membership/gifts/')
    giftableMemberships.value = data.results || []
    loading.value = false
    return true
  }

  return {
    loading,
    sectionState,
    giftableMemberships,
    visibleMemberships,
    setLoading,
    setSectionState,
    clearSectionState,
    setSectionDrawerOpen,
    loadMemberships,
  }
})
